import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

import OANecessity from "@/components/modal/OAModals/ModalOANecessity/ModalOANecessity";
import OAPreview from "@/components/modal/OAModals/ModalOAPreview/OAPreview";
import OANotice from "@/components/modal/OAModals/ModalOANotice/ModalOANotice";
import OAProductConsumption from "@/components/modal/OAModals/ModalOAProductConsumption/ModalOAProductConsumption";

const OA_MODAL_COMPONENT_BY_OPTION = {
	calcular_necesidad: OANecessity,
	vista_previa: OAPreview,
	dar_aviso: OANotice,
	consumir_productos: OAProductConsumption,
};

const OAModals = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const [searchParams] = useSearchParams();

	const option = searchParams.get("action");
	const code = searchParams.get("oa");

	if (!option || !code) {
		return null;
	}

	const OAModalComponent = OA_MODAL_COMPONENT_BY_OPTION[option];
	if (!OAModalComponent) {
		return null;
	}

	const handleClose = () => {
		const updatedSearchParams = new URLSearchParams(location.search);
		updatedSearchParams.delete("action");
		updatedSearchParams.delete("oa");

		navigate(
			{
				pathname: location.pathname,
				search: updatedSearchParams.toString() ? `?${updatedSearchParams.toString()}` : "",
				hash: location.hash,
			},
			{ replace: true },
		);
	};

	return <OAModalComponent code={code} applicationCodes={code} onClose={handleClose} />;
};

export default OAModals;
